import React from "react";
import { Button, Col, Container, Row,ModalHeader,Modal,ModalBody,ModalFooter, CardBody } from "reactstrap";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import Table from "./component/emailTable";
import firebase from '../../config/firebase'
import BorderedTable from "../../shared/components/table/BorderedTable";

class Email extends React.Component{
  state={
    loading:false,
    isOpen:false,
    subscriber:[]
  }

  toggle=()=>{
    this.setState({isOpen:!this.state.isOpen})
  }

  getData=()=>{
    let arr =[]
    const db = firebase.firestore();
    db.collection('subscriptions').get()
    .then(res=> {
      res.forEach(doc=>{
        console.log(doc.data())
        arr.push(doc.data())
      })

      console.log(arr);
      this.setState({subscriber:arr})
    });
  }
  render(){
    const {loading,isOpen,subscriber} = this.state


return (
  <Container>
    <Row>
      <Col md={12}>
          <h1>News Letters</h1>
        <Modal isOpen={isOpen} toggle={this.toggle}>
                  <ModalHeader toggle={this.toggle}>
                    Change Job Ammount
                  </ModalHeader>
                  <ModalBody>
                    {/* <Content/> */}
                  </ModalBody>
                  <ModalFooter>
                    <Button
                      color="danger"
                      onClick={this.changePayment}
                      size="sm"
                      disabled={loading}
                    >
                      {loading ? "loading..." : "update"}
                    </Button>{" "}
                    <Button
                      color="secondary"
                      onClick={this.toggle}
                      size="sm"
                      disabled={loading}
                    >
                      Cancel
                    </Button>
                  </ModalFooter>
                </Modal>

      </Col>
      <CardBody>
                      <Table />

      </CardBody>
    </Row>
    <Row>

    </Row>
  </Container>
);
  }
}
Email.propTypes = {
  t: PropTypes.func.isRequired
};

export default Email
